module.exports = __webpack_public_path__ + "static/media/DSC_7417-Edit.b8cd7691.jpg";